/* eslint-disable react/prop-types */
import { onBlankLayout } from "store/slices/themeSlice";
import { useDispatch } from "react-redux";
/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";

const AppRoute = ({
  blankLayout,
  component: Component,
  routeKey,
  ...props
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const isBlank = blankLayout ? true : false;
    dispatch(onBlankLayout(isBlank));
  }, [blankLayout]);

  return <Component {...props} />;
};

export default AppRoute;
